module.exports = __webpack_public_path__ + "img/plus.69b7216c.svg";